/**
 * 拍卖模态框
 * @description type                模态框类型 'endSimulate'|'close'|'begin'|'hasAnswer'|'noAnswer'
 *                                            结束模拟拍卖|结束拍卖|开始正式拍卖|有人应价|无人应价
 * @description id                  场次id(结束模拟拍卖|结束拍卖|开始正式拍卖) 或者 车辆id(有人应价|无人应价)
 * @description auctionId[可选]      车辆竞拍id 结束拍卖接口需要传参数
 * @description showCloseModal      是否展示模态框
 * @description cancelClose         点击模态框里取消按钮的回调
 * @description okClose             点击模态框里确认|开始按钮的回调
 * @description isTheLast[可选]      该辆车是否是最后一辆车 默认不传是非最后一辆车
 *                                  isTheLast这里目前涉及到的是 有人应价|无人应价
 * @description countNum[可选]       有人应价和无人应价弹框里的秒数
 *                                  countNum这里目前涉及到的是 有人应价|无人应价
 */
import React, { Component } from 'react';
import { Modal, Icon, Button } from 'antd';
import Api from '../../../../../services/index';
import { dispatch } from '../../../../../.muji/store';
class CloseAuctionModal extends Component {
    constructor() {
        super(...arguments);
        this.handleOk = () => {
            const { id, type, okClose, auctionId } = this.props;
            let _param;
            switch (type) {
                case 'begin':
                case 'endSimulate':
                    _param = {
                        roundId: id,
                        simulateTag: 0,
                    };
                    Api.auction.startAuction(_param).then((_r) => {
                        if (_r) {
                            okClose();
                            dispatch.auctionOperate.resetAndclear({});
                            dispatch.auctionOperate.load({});
                        }
                    });
                    break;
                case 'close':
                    _param = {
                        roundId: id,
                        auctionId,
                    };
                    Api.auction.endAuction(_param).then((_r) => {
                        if (_r) {
                            okClose();
                            dispatch.auctionOperate.dealEnd({ roundId: id });
                        }
                    });
                    break;
                case 'hasAnswer':
                    okClose();
                    break;
                case 'noAnswer':
                    okClose();
                    break;
            }
        };
        this.handleCancel = () => {
            const { cancelClose } = this.props;
            cancelClose();
        };
        this.getTitle = (type, isTheLast, countNum) => {
            let title;
            let content;
            switch (type) {
                case 'endSimulate':
                    title = '结束模拟拍卖';
                    content = '您确定要结束模拟拍卖，开始正式拍卖吗？';
                    break;
                case 'close':
                    title = '结束拍卖';
                    content = '您确定要结束本场拍卖吗？';
                    break;
                case 'begin':
                    title = '开始正式拍卖';
                    content = '模拟拍卖已结束，是否直接开始正式拍卖？';
                    break;
                case 'hasAnswer':
                    title = '应价提示';
                    content = isTheLast ? `车辆已有人应价并成交，${countNum}秒后结束本场次拍卖。` : `车辆已有人应价并成交，${countNum}秒后开始下一辆车拍卖。`;
                    break;
                case 'noAnswer':
                    title = '应价提示';
                    content =
                        isTheLast ? `倒计时内车辆无人应价，车辆进入待成交状态，${countNum}秒后结束本场次拍卖。` : `倒计时内车辆无人应价，车辆进入待成交状态，${countNum}秒后开始拍卖下一辆车辆。`;
                    break;
            }
            return { title, content };
        };
        this.getFooter = (type) => {
            const footer = [];
            footer.push(<Button key="back" onClick={this.handleCancel}>取消</Button>);
            footer.push(<Button key="submit" type="primary" onClick={this.handleOk}>
        开始
      </Button>);
            if (type === 'close') {
                footer.pop();
                footer.push(<Button key="submit" type="primary" onClick={this.handleOk}>
          确定
        </Button>);
            }
            if (type === 'hasAnswer' || type === 'noAnswer') {
                footer.pop();
                footer.pop();
                footer.push(<Button key="submit" type="primary" onClick={this.handleOk}>
          确定
        </Button>);
            }
            return footer;
        };
    }
    render() {
        const { showCloseModal, type, isTheLast, countNum } = this.props;
        const { title, content } = this.getTitle(type, isTheLast, countNum);
        return (<Modal title={title} visible={showCloseModal} onOk={this.handleOk} onCancel={this.handleCancel} okText="开始" footer={this.getFooter(type)}>
        <div className="flex__row-start">
          <Icon type="exclamation-circle" theme="filled" style={{ color: '#FF571A', fontSize: 24 }}/>
          <span style={{ marginLeft: '10px' }}>{content}</span>
        </div>

      </Modal>);
    }
}
export default CloseAuctionModal;
